import { render, staticRenderFns } from "./UserFavList.vue?vue&type=template&id=49985b56&scoped=true&"
import script from "./UserFavList.vue?vue&type=script&lang=js&"
export * from "./UserFavList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49985b56",
  null
  
)

export default component.exports